import React from 'react'
import { Routes, Route } from "react-router-dom";
import ProtectedRoutes from './ProtectedRoute';
import Login from '../pages/Login';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/HomePage';
import AboutDoctor from '../components/doctors/abouts/AboutDoctor';
import RegistrationFormComponent from '../components/doctors/abouts/registrationForm/RegistrationForm';
import ShowDiploms from '../components/diploms/ShowDiploms';

const MyRoutes:React.FC = () => {

  return (
    <Routes>
      <Route element={<ProtectedRoutes />  }>
        <Route path="/" element={<HomePage />}/>

        <Route path="/doctor/:doctorId/about" element={<AboutDoctor />} >
          <Route path="regform" element={<RegistrationFormComponent />} />
          <Route path="diploms" element={<ShowDiploms />} />
        </Route>

        <Route path="/login" element={<Login />}/>
        <Route path="*" element={<NotFound />}/>
      </Route>
    </Routes>
  )
}

export default MyRoutes
